import Api from './Api';

class TipoComposicaoService {
  constructor() {
    this.$api = Api;
  }

  async findAll(filters) {
    return this.$api.get('/tipos-composicao', filters);
  }

  async save(data) {
    const id = data.id || 0;

    if (id === 0) {
      return this.$api.post('/tipo-composicao', data);
    }

    return this.$api.put(`/tipo-composicao/${id}`, data);
  }

  async findById(id) {
    return this.$api.get(`/tipo-composicao/${id}`);
  }

  async remove(id) {
    return this.$api.delete(`/tipo-composicao/${id}`);
  }
}

export default new TipoComposicaoService();
